import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { paths } from "@clevis/shared-types";
import { db } from "../lib/firebase";

// uid → human name, for anywhere a record stores just a uid. Never surface a
// raw uid to a screen (house rule since the "On the clock" incident).
export function useMemberNames(tenantId: string | null): (uid: string) => string {
  const [names, setNames] = useState<Record<string, string>>({});

  useEffect(() => {
    if (!tenantId) return;
    return onSnapshot(collection(db, paths.tenantMembers(tenantId)), (snap) => {
      const next: Record<string, string> = {};
      snap.docs.forEach((d) => {
        next[d.id] = (d.get("displayName") as string) || (d.get("email") as string) || "";
      });
      setNames(next);
    });
  }, [tenantId]);

  return (uid: string) => names[uid] || "Teammate";
}
